"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useLiveRef_1 = __importDefault(require("stremio/common/useLiveRef"));
var usePlaybackSpeedHold = function (enabled, stream, playbackSpeed, setPlaybackSpeed) {
    var speedRef = (0, useLiveRef_1.default)(playbackSpeed);
    var holdRef = (0, react_1.useRef)(null);
    var suppressClickRef = (0, react_1.useRef)(false);
    var finish = (0, react_1.useCallback)(function (source) {
        var hold = holdRef.current;
        if (!hold || (source && source !== hold.source))
            return null;
        holdRef.current = null;
        if (hold.timer !== null)
            clearTimeout(hold.timer);
        if (hold.active) {
            if (hold.source === 'pointer')
                suppressClickRef.current = true;
            setPlaybackSpeed(hold.speed);
        }
        return hold.active ? 'held' : 'pending';
    }, [setPlaybackSpeed]);
    var cancel = (0, react_1.useCallback)(function () {
        finish();
    }, [finish]);
    var start = (0, react_1.useCallback)(function (source) {
        var _a;
        if (!enabled || holdRef.current)
            return;
        suppressClickRef.current = false;
        var hold = { source: source, timer: null, speed: (_a = speedRef.current) !== null && _a !== void 0 ? _a : 1, active: false };
        hold.timer = setTimeout(function () {
            hold.timer = null;
            hold.active = true;
            setPlaybackSpeed(2);
        }, 400);
        holdRef.current = hold;
    }, [enabled, setPlaybackSpeed, speedRef]);
    var isActive = (0, react_1.useCallback)(function () { return holdRef.current !== null; }, []);
    var consumeClick = (0, react_1.useCallback)(function () {
        var suppressed = suppressClickRef.current;
        suppressClickRef.current = false;
        return suppressed;
    }, []);
    (0, react_1.useLayoutEffect)(function () {
        if (!enabled)
            cancel();
        return cancel;
    }, [enabled, stream, cancel]);
    return { start: start, finish: finish, cancel: cancel, isActive: isActive, consumeClick: consumeClick };
};
exports.default = usePlaybackSpeedHold;
